import React, { Component } from 'react';
import "../assets/scss/sidebar.scss";
import CentralNavBar from "../components/CentralNavBar";
import { connect } from "react-redux";

class Sidebar extends Component {
  render() {
    return (
      <div className={this.props.navbar.isNavbarShowing ? 'sidebar' : 'sidebar collapsed-sidebar'}>
        <CentralNavBar />
        <div className="sidebar-footer">
          <span>&copy; 2021 <span className="pointer-event"
            style={{ marginLeft: "20px", marginRight: "20px" }}
            onClick={() => window.open(`https://agami.ltd/`, "_blank")}>
            Agami Ltd.
          </span></span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    navbar: state.navbar
  }
};

export default connect(mapStateToProps)(Sidebar);
